import React from "react";
import PropTypes from "prop-types";

export const VerticalLine = ({ color }) => (
  <div>
    <div
      style={{
        left: 41,
        content: "",
        height: "1px",
        width: "26px",
        background: color,
        marginLeft: "-18px",
        position: "absolute",
        top: 65,
      }}
    />
    <div
      className="vertical-line"
      style={{
        borderLeft: `10px solid ${color}`,
        height: "calc(100% - 65px)",
        width: 1,
        position: "absolute",
        zIndex: 2,
        top: 65,
        left: 13,
        marginLeft: "18px",
        marginRight: "-25px",
      }}
    />
    <div
      style={{
        left: 41,
        content: "",
        height: "1px",
        width: "26px",
        background: color,
        marginLeft: "-18px",
        position: "absolute",
        bottom: 0,
      }}
    />
  </div>
);

VerticalLine.propTypes = {
  color: PropTypes.string.isRequired, // Default to blue?
};
